import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Edit, Trash2, Tag } from "lucide-react";  
import { UnitDialog } from "./UnitDialog"; 
import { useUnitStore } from "../../../store/unitStore";
import { Unit } from "../../../types/unit";
import { useTableHeader } from "../../../hooks/useTableHeader";
import { useDynamicScrollHeight } from "../../../hooks/useDynamicScrollHeight";
import { useConfirmModal } from "../../../hooks/useConfirmModal";
import { IconButton, TextButton } from "../../../components/ButtonComponents";

export const UnitList = () => {
  const { data, loading, fetchDataDynamic, createItem, updateItem, deleteItem } = useUnitStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<Unit | null>(null);
  
  const scrollHeight = useDynamicScrollHeight(260);
  const { confirm, modal: confirmModal } = useConfirmModal();

  useEffect(() => {
    fetchDataDynamic();
  }, []);

  const handleEdit = (unit: Unit) => {
    setSelectedUnit(unit);
    setIsModalOpen(true);
  };

  const handleDelete = async (unit: Unit) => {
    if (await confirm(`${unit.name} birimi silinecek. Emin misiniz?`)) {
      await deleteItem(unit.id);
      fetchDataDynamic();
    }
  };

  const actionBody = (rowData: Unit) => (
    <div className="flex gap-2 justify-center">
      <IconButton icon={Edit} onClick={() => handleEdit(rowData)} className="text-blue-600" />
      <IconButton icon={Trash2} onClick={() => handleDelete(rowData)} className="text-red-500" />
    </div>
  );

 

  return (
    <div >
      {confirmModal}
      <DataTable
        value={data}
        loading={loading}
        header={useTableHeader({
          title: "Birim Tanımları",
          actions: <TextButton onClick={() => { setSelectedUnit(null); setIsModalOpen(true); }}>Yeni Birim</TextButton>,
          onFilterChange: (f) => fetchDataDynamic({ filter: f ?? undefined })
        }).header}
        scrollable
        scrollHeight={scrollHeight}
        className="p-datatable-sm"
      >
        <Column field="code" header="Birim Kodu" sortable style={{ width: '20%' }} />
        <Column field="name" header="Birim Adı" sortable style={{ width: '50%' }} /> 
        <Column header="İşlemler" body={actionBody} style={{ width: '15%' }} />
      </DataTable>

      <UnitDialog
        isOpen={isModalOpen}
        unit={selectedUnit}
        onClose={() => setIsModalOpen(false)}
        onSave={(payload) => {
          if (selectedUnit) {
            updateItem(selectedUnit.id, payload).then(() => fetchDataDynamic());
          } else {
            createItem(payload).then(() => fetchDataDynamic());
          }
        }}
      />
    </div>
  );
};